// src/layout/theme/theme.dev.ts
var previewBarIframe = null;
function setupPreviewIcon() {
  const previewIcon = document.createElement("button");
  previewIcon.classList.add("bg-primary");
  previewIcon.style.display = "none";
  previewIcon.style.position = "fixed";
  previewIcon.style.bottom = "0.5rem";
  previewIcon.style.right = "0.5rem";
  previewIcon.id = "preview-icon";
  previewIcon.style.zIndex = "999";
  previewIcon.style.width = "12px";
  previewIcon.style.height = "12px";
  previewIcon.style.cursor = "pointer";
  previewIcon.onclick = () => {
    togglePreviewBar();
  };
  document.body.appendChild(previewIcon);
}
function togglePreviewBar() {
  if (previewBarIframe != null) {
    const previewIcon = document.getElementById("preview-icon");
    if (previewBarIframe.style.display === "none") {
      previewBarIframe.style.display = "block";
      previewIcon.style.display = "none";
      sessionStorage.setItem("removePreviewBar", "false");
    } else {
      previewBarIframe.style.display = "none";
      previewIcon.style.display = "block";
      sessionStorage.setItem("removePreviewBar", "true");
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  var _a;
  previewBarIframe = document == null ? void 0 : document.getElementById("preview-bar-iframe");
  if (previewBarIframe != null) {
    const removePreviewBar = sessionStorage.getItem("removePreviewBar");
    setupPreviewIcon();
    (_a = previewBarIframe.contentWindow) == null ? void 0 : _a.addEventListener("DOMContentLoaded", () => {
      var _a2, _b, _c, _d, _e, _f;
      const hasError = ((_d = (_c = (_b = (_a2 = previewBarIframe == null ? void 0 : previewBarIframe.contentWindow) == null ? void 0 : _a2.document) == null ? void 0 : _b.body) == null ? void 0 : _c.classList) == null ? void 0 : _d.contains("status-code-500")) === true;
      if (hasError || removePreviewBar === "true") {
        togglePreviewBar();
      }
      ((_e = previewBarIframe == null ? void 0 : previewBarIframe.contentWindow) == null ? void 0 : _e.document.querySelectorAll("[data-hide-bar-button]")).forEach((button) => {
        button.outerHTML = button.outerHTML;
      });
      ((_f = previewBarIframe == null ? void 0 : previewBarIframe.contentWindow) == null ? void 0 : _f.document.querySelectorAll("[data-hide-bar-button]")).forEach((button) => {
        button.addEventListener("click", (e) => {
          e.stopImmediatePropagation();
          togglePreviewBar();
        });
      });
    });
  }
});
